module.exports = __webpack_public_path__ + "img/icon_white_message.ae6f6f83.png";